import { useSejamCheckStore } from '@shared/store';
import { FeatureFlagEnum, useFeatureFlags } from '@shared/feature';
import { useUserInfoStore } from '../../user';

export const useSejam = () => {
  const userInfoStore = useUserInfoStore((state) => state.data);
  const setOpen = useSejamCheckStore((state) => state.setOpen);
  const { checkFeature } = useFeatureFlags();

  const handleSejamCheck = (action?: () => any) => {
    const isSejamCheckEnabled = checkFeature(FeatureFlagEnum.sejamCheckEnabled);
    const isInTseMarket = userInfoStore?.isInTseMarket;

    if (!isInTseMarket) {
      if (action) action();
      return;
    }

    if (!userInfoStore?.isSejami) {
      setOpen(true);
      return;
    }

    if (isSejamCheckEnabled && !userInfoStore?.hasUpdatedSejamInfo) {
      setOpen(true);
      return;
    }
    if (action) action();
  };

  return {
    handleSejamCheck,
  };
};
